import React, { useState } from 'react';
import { parseInlineMarkdown } from '../../../../../../utils/LearnTab/slideTextRenderer';
import { tUi } from '../../../../../../../../../utils/dq_lc';
import { PointText } from '../../../../../../styles/LearnTab/slideBase.styles';
import { SlideImageLightboxModal } from '../../common/SlideImageLightbox.comp';

export const WhyOutcomeCards = ({ slide, onImageClick, uiLocale = 'en-US' }) => {
  const [internalLightbox, setInternalLightbox] = useState(null);
  const origin = slide?._pbdq_origin || slide || {};

  const doWell = origin.positive_outcome || origin.if_you_do_this_well || '';
  const skipThis = origin.negative_outcome || origin.if_you_skip_this || '';
  const posLabel = origin.positive_label || tUi('slide.outcome.ifYouDoThisWell', uiLocale);
  const negLabel = origin.negative_label || tUi('slide.outcome.ifYouSkipThis', uiLocale);
  const posIcon = (origin.positive_icon || '').trim();
  const negIcon = (origin.negative_icon || '').trim();
  const takeaway = origin.takeaway || '';
  const bodyText = origin.body_text || origin.message || '';

  const posImg = origin.positive_image_url || origin.positive_image || slide.positive_image_url || null;
  const negImg = origin.negative_image_url || origin.negative_image || slide.negative_image_url || null;
  const hasOutcomeImages = Boolean(posImg || negImg);

  const handleImgClick = (img) => {
    if (onImageClick) {
      onImageClick(img);
    } else {
      setInternalLightbox(img);
    }
  };

  if (!doWell && !skipThis) {
    return <PointText>{parseInlineMarkdown(bodyText || slide.SlideContent)}</PointText>;
  }

  return (
    <>
      <div className={`outcome-container ${hasOutcomeImages ? 'centered-container' : ''}`}>
        <div className={`outcome-grid ${hasOutcomeImages ? 'centered-grid' : ''}`}>
          {doWell && (
            <div className="outcome-card positive">
              {posImg && (
                <div className="outcome-card-image-wrap">
                  <img
                    src={posImg}
                    alt="Positive outcome"
                    onClick={() => handleImgClick(posImg)}
                    className="outcome-card-image"
                  />
                </div>
              )}
              <div className="outcome-header positive">
                {posIcon && <span className="outcome-icon positive">{posIcon}</span>}
                <span className="outcome-title positive">{posLabel}</span>
              </div>
              <div className="outcome-body positive">
                {parseInlineMarkdown(doWell)}
              </div>
            </div>
          )}
          {skipThis && (
            <div className="outcome-card negative">
              {negImg && (
                <div className="outcome-card-image-wrap">
                  <img
                    src={negImg}
                    alt="Negative outcome"
                    onClick={() => handleImgClick(negImg)}
                    className="outcome-card-image"
                  />
                </div>
              )}
              <div className="outcome-header negative">
                {negIcon && <span className="outcome-icon negative">{negIcon}</span>}
                <span className="outcome-title negative">{negLabel}</span>
              </div>
              <div className="outcome-body negative">
                {parseInlineMarkdown(skipThis)}
              </div>
            </div>
          )}
        </div>
        {takeaway && (
          <div className="content-so-what">
            {parseInlineMarkdown(takeaway)}
          </div>
        )}
      </div>

      {!onImageClick && (
        <SlideImageLightboxModal
          image={internalLightbox}
          onClose={() => setInternalLightbox(null)}
        />
      )}
    </>
  );
};

export default WhyOutcomeCards;
